import React from 'react'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

import Icons from '@olxbr/olx-icons'

const Box = styled(View)`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  min-height: 73px;
  border-radius: 4px;
  background-color: #fef7e9;
  padding: 16px;
  border: 1px solid #f9af27;
`

const DetailColumn = styled(View)`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: 16px;
  justify-content: center;
`

/* eslint-disable react/prop-types */
const GenericWarningBox = ({ className, style, children }) => (
  <Box className={className} style={style}>
    <Icons.System.AlertCircle color="#F9AF27" size="18" />
    <DetailColumn>{children}</DetailColumn>
  </Box>
)

export default GenericWarningBox
